import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigation} from '@react-navigation/native';
import type {NativeStackNavigationProp} from '@react-navigation/native-stack';

import type {SettingsStackParamList} from '@/app/routes';
import {useAuthStore} from '@/entities/session/auth-store';
import {DepartmentList} from '@/features/manage-departments/ui/DepartmentList';
import {Page} from '@/shared/ui/page';
import {SettingsNav, useInSettings} from '@/pages/settings/SettingsNav';
import {ContextPlaceholder} from '@/widgets/context-placeholder/ContextPlaceholder';

/**
 * "Организация" → Отделы. Scoped to the active company context; the placeholder guards
 * only the impossible case of a company tab with no active context.
 */
export function DepartmentsScreen() {
  const {t} = useTranslation();
  const navigation =
    useNavigation<NativeStackNavigationProp<SettingsStackParamList>>();
  const companyId = useAuthStore(s => s.activeContext?.companyId);
  const inSettings = useInSettings();
  if (!companyId) {
    return <ContextPlaceholder titleKey="nav.departments" />;
  }
  return (
    // Заголовка у этой страницы не было вовсе: раздел назывался только строкой в
    // «Настройках», по которой на него зашли, и открытый по ссылке он не назывался
    // нигде. Слово в крошке и слово в заголовке — одно и то же, «Отделы».
    <Page sideNav={inSettings ? <SettingsNav /> : undefined} title={t('nav.departments')} testID="company-departments">
      <DepartmentList
        companyId={companyId}
        onOpen={d => navigation.navigate('Department', {deptId: d.id, name: d.name})}
      />
    </Page>
  );
}
